/* global _satellite */
'use strict';

const { initSwatch } = require('../components/productTile');

var $compareBar = $('.compare-bar-wrapper');
var maxSlots = parseInt($('.compare-bar').data('max-slots'), 10);
var productsForComparison = [];
var $prevSkipLink;
var isCompareModalOpen = false;

require('../../icons/genericfeatures.svg');
require('../../icons/genericfabric.svg');
require('../../icons/iconrun.svg');
require('../../icons/rise.svg');
require('../../icons/inseam.svg');
require('../../icons/length.svg');
require('../../icons/fit.svg');
require('../../icons/support.svg');
require('../../icons/warmth.svg');
require('../../icons/bagSize.svg');


/**
 * @typedef ProductComparisonList
 * @type Object
 * @property {string} pid - ID for product to compare
 * @property {string} imgSrc - Image URL for selected product
 */

/**
 * Compiles the HTML for a single slot
 *
 * @param {ProductComparisonList} product - Selected product to compare
 * @param {number} idx - Slot number (zero-based)
 * @return {string} - HTML for a single slot
 */
function compileSlot(product, idx) {
    var pid = product.pid;
    var name = 'pid' + idx;

    return '' +
        '<div class="selected-product">' +
            '<div class="slot" data-pid="' + pid + '">' +
                '<img alt="' + product.altText + '" src="' + product.imgSrc + '">' +
                '<button type="button" class="close" aria-label="remove ' + product.altText + ' from compare list">' +
                    '<svg><use xlink:href="#cross"></use></svg>' +
                '</button>' +
            '</div>' +
            '<input type="hidden" name="' + name + '" value="' + pid + '">' +
        '</div>\n';
}

/**
 * Draw and render the Compare Bar product slots
 *
 * @param {ProductComparisonList []} productsToCompare - List of ID's of the products to compare
 */
function redrawCompareSlots(productsToCompare) {
    var html = productsToCompare.map(function (product, idx) {
        return compileSlot(product, idx);
    }).join('');

    // Render empty slots
    if (productsToCompare.length < maxSlots) {
        var numAvailableSlots = maxSlots - productsToCompare.length;

        for (var i = 0; i < numAvailableSlots; i++) {
            if (productsToCompare.length < 3) {
                html += '<div class="selected-product"><div class="slot"></div></div>';
            }
        }
    }

    $('.compare-bar .product-slots').empty().append(html);
}

/**
 * Enables/disables the Compare button, depending on whether at least two products have been
 * selected for comparison
 *
 * @param {number} numProducts - Number of products selected for comparison
 */
function setCompareButton(numProducts) {
    if (numProducts < 1) {
        $('.compare-btn').attr('disabled', true);
        $('.compare-btn').addClass('disabled');
    } else {
        $('.compare-btn').prop('disabled', false);
        $('.compare-btn').removeClass('disabled');
    }
}

/**
 * Returns a copy of a list of products to compare
 *
 * @param {ProductComparisonList []} productsToCompare - List of ID's of the products to compare
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function copyProducts(productsToCompare) {
    return productsToCompare.map(function (product) {
        var proxy = {};

        Object.keys(product).forEach(function (key) {
            proxy[key] = product[key];
        });

        return proxy;
    });
}

/**
 * Handles the selection of a product for comparison
 *
 * @param {ProductComparisonList []} products - List of ID's of the products to compare
 * @param {string} pid - ID for product to compare
 * @param {string} imgSrc - Image URL for selected product
 * @param {string} altText - Alt text for selected product image
 * @param {string} swatch - Selected swatch
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function selectProduct(products, pid, imgSrc, altText, swatch) {
    var productsToCompare = copyProducts(products) || [];

    if (productsToCompare.length < maxSlots) {
        productsToCompare.push({
            pid: pid,
            imgSrc: imgSrc,
            altText: altText,
            swatch: swatch
        });

        if (productsToCompare.length === maxSlots) {
            $('input[type=checkbox]:not(:checked)').attr('disabled', true);
        }

        redrawCompareSlots(productsToCompare);
        setCompareButton(productsToCompare.length);
    }

    return productsToCompare;
}

/**
 * Handles the deselection of a product
 *
 * @param {ProductComparisonList []} products - List of ID's of the products to compare
 * @param {string} pid - ID for product to compare
 * @return {ProductComparisonList []} List of ID's of the products to compare
 */
function deselectProduct(products, pid) {
    var productsToCompare = copyProducts(products) || [];

    productsToCompare = productsToCompare.filter(function (product) {
        return product.pid !== pid;
    });

    var sessionProds = JSON.parse(sessionStorage.getItem('savedProducts'));
    var prodIndex = sessionProds.findIndex(obj => obj.pid === pid);
    sessionProds.splice(prodIndex, 1);
    sessionStorage.setItem('savedProducts', JSON.stringify(sessionProds));
    $('input#' + pid).prop('checked', false);
    $('input[type=checkbox]:not(:checked)').prop('disabled', false);

    if (productsToCompare.length < 2) {
        $('.skip-link').addClass('d-none');
    }

    if (productsToCompare.length === 0) {
        $('.compare-btn').addClass('disabled');
    }

    redrawCompareSlots(productsToCompare);
    setCompareButton(productsToCompare.length);
    return productsToCompare;
}

/**
 * Clears the Compare Bar and hides it
 * @return {undefined}
 */
function clearCompareBar() {
    productsForComparison.forEach(function (product) {
        $(this).trigger('compare:deselected', { pid: product.pid });
    });

    productsForComparison = [];
    $('.compare input').prop('checked', false);
    $('.compare input[type=checkbox]:not(:checked)').prop('disabled', false);
    sessionStorage.setItem('savedProducts', '');
    redrawCompareSlots(productsForComparison);
    $('.skip-link').addClass('d-none');
    $('.compare-btn').addClass('disabled');
    isCompareModalOpen = false;
}

/**
 * Adds a scroll listener to maximise/minimize product tiles on scroll
 * @return {undefined}
 */
function animateScroll() {
    var distance = $('#comparisonModal .quickViewLink .quickview')[0].offsetTop;
    if (this.scrollTop >= distance) {
        $('.tile-data').addClass('minimize sticky-top');
        var tileDataHeight = $('.tile-data').outerHeight() + 2;
        $('.tile-section-bg').css('height', tileDataHeight);
    } else if (this.scrollTop === 0) {
        $('.tile-data').removeClass('minimize sticky-top');
    }
}

/**
 * Adds a scroll listener to maximise/minimize product tiles on scroll
 * @return {undefined}
 */
function addModalScrollListener() {
    document.getElementById('comparisonModal').addEventListener('scroll', animateScroll, { passive: true });
}

/**
 * Adds Show more/less link to data blocks in comparison modal based on number of lines
 * @return {undefined}
 */
function styleAttributeDiv() {
    $('.attribute-data').each(function () {
        var height = this.offsetHeight;
        var lineHeight = parseInt($(this).css('line-height'), 10);
        var lines = parseInt(height / lineHeight, 10);
        if (lines > 6 && !$(this).find('.data-block').hasClass('fabric-filter')) {
            $(this).siblings('.show-more').removeClass('d-none');
            $(this).siblings('.gradient').removeClass('d-none');
            $(this).addClass('no-margin');
        }

        if ($(this).find('.data-block').hasClass('material-block')) {
            $(this).addClass('low-margin');
            if ($('.fabric-title').length && lines > 3) {
                $(this).siblings('.show-more').removeClass('d-none');
                $(this).siblings('.gradient').removeClass('d-none');
                $(this).addClass('no-margin low-height');
            }
        }

        if ($(this).find('.data-block').hasClass('fabric-filter')) {
            $(this).parent('.attribute-data-container').addClass('no-border');
        }
    });
}

/**
 * Adjusts height of the product slots to match tile image height
 * @return {undefined}
 */
function resizeProdSlots() {
    var imgHeight = $('#comparisonModal .product-tile .tile-image')[0].offsetHeight;
    $('.modal-prod-slot').css('height', imgHeight);
}

$(document).on('keyup', '.skip-link', function (e) {
    if (e.keyCode === 9) {
        $('.skip-link a').addClass('tabbed');
    }
});

$(document).on('keydown', '.skip-link', function () {
    if (document.activeElement !== this) {
        $('.skip-link a').removeClass('tabbed');
    }
});

$(document).on('keyup', '.attribute-data li', function (e) {
    if (e.keyCode === 9 && e.shiftKey && document.activeElement === this) {
        this.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
});

$(document).on('keydown', '.collapseModal', function (e) {
    if (e.keyCode === 9 && e.shiftKey) {
        $(this).closest('.comparisonModal').find('.attribute-data-container:last-child .data-block:last-child li:last-child').focus();
    }
});

$(document).on('keydown', '.attribute-data-container:last-child .data-block:last-child li:last-child', function (e) {
    if (e.keyCode === 9) {
        $(this).closest('.comparisonModal').find('.collapseModal').focus();
    }
});

$(document).ready(function () {
    if ($('#compareFlag').val() === 'true' && sessionStorage.getItem('compareSwitchOn') === 'true') {
        $('.product-grid .compare').show();
        $('.compare-header').addClass('sticky-top');
        $('.compare-switch')[0].checked = true;
        $('.compare-bar-wrapper').removeClass('d-none');
        setTimeout(function () {
            $('.compare-bar-wrapper').addClass('visible');
        }, 50);

        if ($('.grid-header').hasClass('sticky-top')) {
            $('.grid-header').removeClass('sticky-top');
        }

        if (sessionStorage.getItem('savedProducts') !== null && sessionStorage.getItem('savedProducts') !== '' && JSON.parse(sessionStorage.getItem('savedProducts')).length >= 2) {
            $('.skip-link').removeClass('d-none');
        } else {
            $('.skip-link').addClass('d-none');
        }

        if ((sessionStorage.getItem('savedProducts') !== null && sessionStorage.getItem('savedProducts') !== '' && JSON.parse(sessionStorage.getItem('savedProducts')).length === 0) || sessionStorage.getItem('savedProducts') === null || sessionStorage.getItem('savedProducts') === '') {
            $('.compare-btn').addClass('disabled');
        }

        // Hiding email toaster if product comparison is enabled on load
        if ($('.email-signup-toaster').length) {
            $('.email-signup-toaster').addClass('hide');
        }

        // Hiding quick start if product comparison is enabled on load.
        if ($('.quick-start-popup').length) {
            $('.quick-start-popup').addClass('hide');
        }

        isCompareModalOpen = false;
    }
});

$(document).ready(function () {
    $('.toggle-switch input.compare-switch').on('click', function () {
        if (this.checked) {
            sessionStorage.setItem('compareSwitchOn', 'true');
            $('.product-grid .compare').show(); // Show compare only on products in the grid(hide for recommenders)
            $('.compare-header').addClass('sticky-top');
            $('.compare-switch')[0].checked = true;
            $('.compare-bar-wrapper').removeClass('d-none');
            setTimeout(function () {
                $('.compare-bar-wrapper').addClass('visible');
            }, 50);
            // Hiding email toaster when product comparison is enabled
            if ($('.email-signup-toaster').length) {
                $('.email-signup-toaster').addClass('hide');
            }
            // Hiding Quick start popup when product comparison is enabled
            if ($('.quick-start-popup').length) {
                $('.quick-start-popup').addClass('hide');
            }

            if ($('.grid-header').hasClass('sticky-top')) {
                $('.grid-header').removeClass('sticky-top');
            }
            _satellite.track('compare-toggle:on');
        } else {
            sessionStorage.setItem('compareSwitchOn', 'false');
            $('.compare').hide();
            $('.compare-header').removeClass('sticky-top');
            $('.compare-bar-wrapper').removeClass('visible');
            setTimeout(function () {
                $('.compare-bar-wrapper').addClass('d-none');
            }, 200);
            $('.grid-header').addClass('sticky-top');
            if ($('.email-signup-toaster').hasClass('hide')) {
                $('.email-signup-toaster').removeClass('hide');
            }
            if ($('.quick-start-popup').length && $('.quick-start-popup').hasClass('hide')) {
                $('.quick-start-popup').removeClass('hide');
            }
            _satellite.track('compare-toggle:off');
        }
    });

    $('.compare-btn').on('keydown', function (e) {
        if (e.keyCode === 9) {
            if ($prevSkipLink && !e.shiftKey) {
                $prevSkipLink.focus();
            }
        }
    });

    $('.compare-header .toggle-switch-input').on('keyup', function (e) {
        if (document.activeElement === $('.compare-header .toggle-switch-input')[0] && e.keyCode === 9) {
            $(this).addClass('tabbed');
        }
    });

    $(document).on('keyup', function (e) {
        if (e.keyCode === 9) {
            if (document.activeElement !== $('.compare-header .toggle-switch-input')[0] && $('.compare-header .toggle-switch-input').hasClass('tabbed')) {
                $('.compare-header .toggle-switch-input').removeClass('tabbed');
            }
        }
    });
});

// Show checkboxes on lazy loaded products if compare switch is enabled
var compareSwitchObserver = new MutationObserver(function () {
    if ($('#compareFlag').val() === 'true' && $('.toggle-switch input.compare-switch').length && $('.toggle-switch input.compare-switch')[0].checked) {
        $('.product-grid .compare').show();

        var compareItems = sessionStorage.getItem('savedProducts') !== '' ? JSON.parse(sessionStorage.getItem('savedProducts')) : '';
        if (compareItems !== null && compareItems !== '') {
            compareItems.forEach(function (prod) {
                var pid = prod.pid;
                if ($('input[id=' + pid + ']').length && $('input[id=' + pid + ']')[0].checked === false) {
                    $('input[id=' + pid + ']')[0].checked = true;
                }
            });

            if (compareItems.length >= 2) {
                $('.skip-link').removeClass('d-none');
            }

            if (compareItems.length === 3) {
                $('.compare input:not(:checked)').attr('disabled', 'disabled');
            }
        }
    }
});

compareSwitchObserver.observe(document.querySelector('.product-grid'), { childList: true });

$(document).on('click', '.compare .custom-checkbox label', function (e) {
    e.preventDefault();
    $(this).siblings('input[type=checkbox]').click();
});

$(document).on('click', '.compare .skip-link a', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.compare-bar-wrapper h6').focus();
    $prevSkipLink = this;
});

$(document).on('keypress', '.compare .skip-link a', function (e) {
    if (e.keyCode === 13) {
        $(this).click();
    }
});

$(document).on('keydown', '.compare-bar-wrapper h6', function (e) {
    if (e.shiftKey && e.keyCode === 9) {
        e.preventDefault();
        if ($prevSkipLink) {
            $prevSkipLink.focus();
        }
    }
});

$(document).on('click', '.comparisonModal .toggleView', function (e) {
    e.preventDefault();
    if ($(this).hasClass('show-more')) {
        $(this).siblings('.attribute-data').addClass('expanded').removeClass('no-margin');
        $(this).siblings('.gradient').hide();
        $(this).siblings('.show-less').removeClass('d-none');
        $(this).addClass('d-none');
    } else {
        $(this).siblings('.attribute-data').removeClass('expanded').addClass('no-margin');
        $(this).siblings('.gradient').show();
        $(this).siblings('.show-more').removeClass('d-none');
        $(this).addClass('d-none');
    }
});

$(document).on('click', '.comparisonModal .clear-link', function (e) {
    e.preventDefault();
    clearCompareBar();
    _satellite.track('compare:clear-all-products');
});

$(document).on('click', '.comparisonModal .quickview', function (e) {
    e.preventDefault();
    isCompareModalOpen = true;
    $('#comparisonModal').removeClass('show');
    $('.tile-data').removeClass('minimize');
    setTimeout(function () {
        $('#comparisonModal').modal('hide');
        document.getElementById('comparisonModal').removeEventListener('scroll', animateScroll);
    }, 800);
});

$(document).on('click', '.closeModalView', function (e) {
    e.preventDefault();
    if ($('#compareFlag').val() === 'true' && $('#cdp-page-indicator').length && isCompareModalOpen === true) {
        if ($('.tile-data').hasClass('minimize')) {
            $('.tile-data').removeClass('minimize');
        }
        setTimeout(function () {
            $('#comparisonModal').modal('show');
        }, 600);
    }
});

$(document).on('click', '.comparisonModal .collapseModal', function (e) {
    e.preventDefault();
    isCompareModalOpen = false;
    $('#comparisonModal').removeClass('show');
    $('.tile-data').removeClass('minimize');
    setTimeout(function () {
        $('#comparisonModal').modal('hide');
        document.getElementById('comparisonModal').removeEventListener('scroll', animateScroll);
    }, 800);
});

$(document).on('keypress', '.comparisonModal .collapseModal', function (e) {
    if (e.keyCode === 13) {
        $(this).click();
        $('.compare-bar-wrapper h6').focus();
    }
});

$(document).on('click', '.comparisonModal .product-tile .tile-image, .comparisonModal .product-tile .pdp-link, .comparisonModal .product-tile .price-link, .comparisonModal .product-tile .cdp-ratings', function () {
    _satellite.track('compare:product-tile:click');
});

$('body').on('shown.bs.modal', '#comparisonModal', function () {
    $('#comparisonModal .collapseModal').focus();
    setTimeout(function () {
        var $swatches = $('#comparisonModal .swatches');
        initSwatch($swatches);
        styleAttributeDiv();
        addModalScrollListener();
        resizeProdSlots();
    }, 700);
    $(this).off('shown.bs.modal');
});

module.exports = {
    /**
     * Handles Compare checkbox click
     */
    handleCompareClick: function () {
        $('div.page').on('click', '.compare input[type=checkbox]', function () {
            var pid = $(this).attr('id');
            var checked = $(this).is(':checked');
            var imgSrc = $(this).closest('.product-tile')
                .find('.tile-image')
                .prop('src');
            var altText = $(this).closest('.product-tile')
                .find('.tile-image')
                .attr('alt');
            var swatch = $(this).closest('.product-tile')
                .find('.swatchAnchor.selected').length ?
                $(this).closest('.product-tile').find('.swatchAnchor.selected').data('color-code') : '';

            if (checked) {
                productsForComparison = selectProduct(productsForComparison, pid, imgSrc, altText, swatch);
                $(this).trigger('compare:selected', { pid: pid });
                var prodCompareArray = JSON.stringify(productsForComparison);
                sessionStorage.setItem('savedProducts', prodCompareArray);
                if (JSON.parse(sessionStorage.getItem('savedProducts')).length >= 2) {
                    $('.skip-link').removeClass('d-none');
                }
                _satellite.track('compare:check', {
                    position: productsForComparison.length,
                    text: 'compare'
                });
            } else {
                productsForComparison = deselectProduct(productsForComparison, pid);
                $(this).trigger('compare:deselected', { pid: pid });
                _satellite.track('compare:uncheck', {
                    position: productsForComparison.length,
                    text: 'compare'
                });
            }
        });
    },

    /**
     * Handles the Clear All link
     */
    handleClearAll: function () {
        $('.compare-bar a.clear-all').on('click', function (e) {
            e.preventDefault();
            clearCompareBar();
        });
    },

    /**
     * Handles deselection of a product on the Compare Bar
     */
    deselectProductOnCompareBar: function () {
        $('.compare-bar').on('click', '.close', function (e) {
            e.preventDefault();
            var pid = $(this).closest('.slot').data('pid').toString();
            productsForComparison = deselectProduct(productsForComparison, pid);
            $(this).trigger('compare:deselected', { pid: pid });
        });
    },

    /**
     * Sets the "backUrl" property to the last attribute selected URL to ensure that when the user
     * goes back from the Compare Products page, the previously selected attributes are still
     * selected and applied to the previous search.
     */
    setBackUrl: function () {
        $('.search-results').on('click', '.refinements a', function () {
            $('input[name="backUrl"]').val($(this).prop('href'));
        });
    },

    // Persists selection of products for comparison, on reload
    selectProductsOnReload: function () {
        $(document).ready(function () {
            if ($('#compareFlag').val() === 'true' && sessionStorage.getItem('savedProducts') !== '' && sessionStorage.getItem('savedProducts') !== null) {
                var preSelectedProds = JSON.parse(sessionStorage.getItem('savedProducts'));
                productsForComparison = productsForComparison.concat(preSelectedProds);
                $('.compare .custom-control-input').each(function () {
                    this.checked = false;
                });
                redrawCompareSlots(productsForComparison);
                setCompareButton(productsForComparison.length);
                productsForComparison.forEach(function (prod) {
                    var pid = prod.pid;
                    if ($('input[id=' + pid + ']').length) {
                        $('input[id=' + pid + ']')[0].checked = true;
                    }
                });

                if (productsForComparison.length === 3) {
                    $('.compare input:not(:checked)').attr('disabled', 'disabled');
                }
                $compareBar.show();
            }
        });
    },

    loadComparisonModal: function () {
        $('.compare-btn').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('.cdp-loader').removeClass('hide').attr('aria-busy', 'true');
            $('body').addClass('modal-with-backdrop');
            var pids = [];
            productsForComparison.forEach(function (product) {
                pids.push({ pid: product.pid, colorID: product.swatch.toString() });
            });
            $.ajax({
                url: $(this).data('url'),
                method: 'GET',
                data: {
                    pids: JSON.stringify(pids)
                },
                success: function (response) {
                    $('.cdp-loader').addClass('hide').attr('aria-busy', 'false');
                    $('body').removeClass('modal-with-backdrop');
                    $('#comparisonModal').siblings('.modal-backdrop').remove();
                    $('#comparisonModal').remove();
                    $('body').append(response);
                    $('#comparisonModal').modal('show');
                    if (pids.length < 3) {
                        if (pids.length === 2) {
                            $($('.modal-prod-slot.add-prod')[0]).removeClass('d-none');
                        } else if (pids.length === 1) {
                            $('.modal-prod-slot').removeClass('d-none');
                        }
                    }
                    _satellite.track('compare-button:start');
                },
                error: function () {
                    $('.cdp-loader').addClass('hide').attr('aria-busy', 'false');
                    $('body').removeClass('modal-with-backdrop');
                }
            });
        });
    },

    deleteProductFromModal: function () {
        $(document).on('click', '.remove-compare-product', function (e) {
            e.preventDefault();
            let pid = $(this).siblings('.product').data('pid');
            deselectProduct(productsForComparison, pid);
            var prodIndex = productsForComparison.findIndex(obj => obj.pid === pid);
            productsForComparison.splice(prodIndex, 1);
            var columnName = this.parentElement.className.match(/column-\d+/)[0];
            $('.' + columnName).remove();
            $('.attribute-data-container').each(function () {
                $(this).find('.data-block:first .header-parent').removeClass('d-none');
            });

            if (productsForComparison.length === 2) {
                $($('.modal-prod-slot.add-prod')[0]).removeClass('d-none');
            } else if (productsForComparison.length === 1) {
                $('.modal-prod-slot').removeClass('d-none');
            } else {
                $('.tile-data').removeClass('minimize');
                $('.comparisonModal').modal('hide');
                document.getElementById('comparisonModal').removeEventListener('scroll', animateScroll);
            }
            _satellite.track('compare:remove-product', {
                position: productsForComparison.length
            });
        });
    }
};
